import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import Button from './Button';

import logo from '../images/logo.svg';

const MOBILE_BREAKPOINT = 740;

const NavLink = styled('a')`
  padding: 0.25rem 2rem;
  font-size: 16px;
  flex: 1;
  white-space: nowrap;
  text-align: center;
  color: rgb(110, 110, 110);
  position: relative;
  display: block;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;

  @media (max-width: ${MOBILE_BREAKPOINT + 200}px) {
    padding: 1.5rem 0.8rem;
  }
`;

const Wrapper = styled.nav`
  background: #fff !important;
  box-shadow: 0px 9px 68px 0px rgba(62, 57, 107, 0.1);
  box-sizing: border-box;
  padding: 10px;
  position: relative;
  width: 100vw;
  z-index: 99;
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1140px;
  margin: 0 auto;
  flex-wrap: nowrap;
  padding: 0 20px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0;
  }
`;

const Collapse = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: ${props => (props.isOpen ? 'flex' : 'none')};
    position: absolute;
    z-index: 100;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    padding: 40px 0;
    box-shadow: 0px 25px 40px 0px rgba(62, 57, 107, 0.1);
  }
`;

const NavList = styled.ul`
  display: flex;
  flex-direction: row;
  margin: 0;
  margin-left: auto !important;
  padding: 0;
  list-style: none;
  justify-content: space-between;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    justify-content: stretch;
    width: auto;
    margin: 0 auto;
  }
`;

const NavItem = styled.li`
  flex: 1;
  display: flex;
  align-items: center;
`;

const MenuBtn = styled.button`
  border: none;
  background: transparent;
  height: 54px;
  width: 54px;
  position: relative;

  @media (min-width: ${MOBILE_BREAKPOINT - 1}px) {
    display: none;
  }

  &:before {
    content: ' ';
    border-bottom: solid 2px #444;
    width: 24px;
    height: 0;
    transform: ${props =>
      props.isOpen ? 'rotate(45deg) translate(3%,-152%)' : ''};
    position: absolute;
    top: 46%;
    transform-origin: center;
  }
  &:after {
    border-bottom: ${props => (!props.isOpen ? 'solid 2px #444' : 'none')};
    border-top: solid 2px #444;
    width: 24px;
    height: 14px;
    content: ' ';
    top: 32%;
    transform: ${props =>
      props.isOpen ? 'rotate(-45deg) translate(12%,48%)' : ''};
    position: absolute;
    transform-origin: center;
  }

  &:focus {
    outline: none;
  }
`;

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Wrapper>
      <Inner>
        <a href="/">
          <img style={{ width: '110px' }} src={logo} alt="Say I do" />
        </a>
        <MenuBtn isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
        <Collapse isOpen={isOpen}>
          <NavList>
            {/* <NavItem>
              <NavLink href={"/features"}>Features</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={"/pricing"}>Pricing</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={"/faq"}>FAQ</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="https://help.sayi.do" target="_blank">
                Help
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink href={`/login`}>Sign In</NavLink>
            </NavItem>
            <NavItem>
              <Button
                href="/create?utm_source=sayido&utm_medium=directory&utm_campaign=header"
                type={'primaryLight'}
              >
                Create Account
              </Button>
            </NavItem>
          </NavList>
        </Collapse>
      </Inner>
    </Wrapper>
  );
}
